import { useMemo } from 'react';
import useClientSide from './useClientSide';

let size: number | undefined;

export function calculateScrollBarWidth(recalculate?: boolean) {
  if (size != null && !recalculate) {
    return size;
  }

  const scrollDiv = document.createElement('div');
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.width = '50px';
  scrollDiv.style.height = '50px';
  scrollDiv.style.overflow = 'scroll';

  document.body.appendChild(scrollDiv);
  size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);

  return size;
}

/**
 * Returns the width of the scrollbar in pixels.
 *
 * @param recalculate If true, the scrollbar width will be recalculated.
 */
export default function useScrollbarWidth(
  recalculate?: boolean
): number | undefined {
  const isClientSide = useClientSide();

  return useMemo(
    () => (isClientSide ? calculateScrollBarWidth(recalculate) : undefined),
    [isClientSide, recalculate]
  );
}
